module.exports = __webpack_public_path__ + "img/1278345733.3ca4d7b9.jpg";